// Хуваарийн харагдац (admin-ы tuition_front/.../timetable/WeekView.jsx-ийн хуулбар, dayjs) — "Хичээлийн хуваарь.html"-ийн бүтэц, класс (timetable.css, .tas-tt дотор).
// buildBlocks: тухайн өдрийн блокууд (өглөөний Assembly/House meet, нэгтгэсэн хичээл, чөлөөт цаг).
// ctx: { view: "section", code } — анги харагдац (багш, хамт орох анги, сонгон хичээлийн сонголтууд)
//      { view: "teacher" }       — багш харагдац (анги, танхим)
import React from "react";
import dayjs from "dayjs";
import "./timetable.css";

export const DAY_MN = ["Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан"];
export const DAY_SHORT = ["Да", "Мя", "Лх", "Пү", "Ба"];
export const LEGEND = [["core", "Энгийн хичээл"], ["elective", "Сонгон хичээл"], ["prep", "Бэлтгэл, төсөл, бие даалт"], ["review", "Давтлага"], ["free", "Чөлөөт цаг"]];
const SUBJECT_NAMES = { "МХТ": "Мэдээлэл технологи", "Коллежийн бэлтгэл": "College prep" };
export const subjectName = (s) => SUBJECT_NAMES[s] || s;
const sectionCodes = (s) => s.groups.filter((g) => g.type === "Үндсэн").map((g) => g.code);
const toMin = (t) => { const [h, m] = String(t).split(":").map(Number); return h * 60 + m; };
export const timeFor = (meta, day, p) => ((day === 2 || day === 4) && meta?.periodsTueThu?.[p]) || meta?.periods?.[p] || ["", ""];
const ROW = (p) => (p <= 4 ? p + 2 : p + 3); // 1 = толгой, 7 = үдийн хоол
// compact — утасны жижиг долоо хоног
export const gridRows = (maxP, head, compact) => {
  const rows = [compact ? "26px" : head];
  for (let p = 0; p <= maxP; p++) { if (p === 5) rows.push(compact ? "18px" : "40px"); rows.push(p === 0 ? (compact ? "24px" : "52px") : compact ? "minmax(36px, auto)" : "minmax(64px, auto)"); }
  return rows.join(" ");
};

export function buildBlocks(slots, day, meta, ctx) {
  const byP = {};
  slots.filter((s) => s.day === day).forEach((s) => { (byP[s.period] = byP[s.period] || []).push(s); });
  const last = Math.max(0, ...Object.keys(byP).map(Number));
  const keyOf = (list) => (list.length ? list.map((s) => (s.kind === "elective" ? `E|${s.electiveCode}` : [s.kind, s.title, s.teacherId, s.note, ctx.view === "teacher" ? sectionCodes(s).join(",") : ""].join("|"))).sort().join("||") : "free");
  const out = [{ key: "m", kind: "morning", p0: 0, p1: 0, title: day % 2 === 1 ? "Assembly" : "House meet", sub: "", opts: [] }];
  for (let p = 1; p <= last; p++) {
    const list = byP[p] || [];
    const k = keyOf(list);
    const prev = out[out.length - 1];
    if (prev.key === k && prev.p1 === p - 1 && p !== 5) { prev.p1 = p; continue; } // үдийн хоолыг давуулж нэгтгэхгүй
    if (!list.length) { out.push({ key: k, kind: "free", p0: p, p1: p, title: "Чөлөөт цаг", sub: "", opts: [] }); continue; }
    const e = list[0];
    let sub = "";
    let opts = [];
    if (e.kind === "elective") {
      sub = e.electiveCode ? `Бүлэг ${e.electiveCode}` : "";
      opts = list.map((s) => ({ s: subjectName(s.title), t: s.teacher || "", r: s.room || "—" }));
    } else if (ctx.view === "teacher") {
      sub = sectionCodes(e).join(", ");
      if (e.room) opts = [{ s: "Танхим", t: "", r: e.room }];
    } else {
      const parts = [];
      if (e.teacher) parts.push(`${e.teacher} багш`);
      const others = sectionCodes(e).filter((c) => c !== ctx.code);
      if (others.length) parts.push(`${others.join(", ")} ангитай хамт`);
      if (e.kind === "review") parts.push("давтлага");
      sub = parts.join(" · ");
    }
    const title = e.kind === "elective" ? "Сонгон хичээл" : e.kind === "pbl" ? "Life skills" : subjectName(e.title);
    out.push({ key: k, kind: e.kind, p0: p, p1: p, title, sub, opts });
  }
  const now = dayjs();
  const nowMin = now.hour() * 60 + now.minute();
  const isToday = (now.day() || 7) === day;
  return out.map((b) => {
    const start = timeFor(meta, day, b.p0)[0], end = timeFor(meta, day, b.p1)[1];
    return { ...b, start, end, isNow: isToday && !!start && nowMin >= toMin(start) && nowMin < toMin(end), dur: b.p0 === 0 ? "50 мин" : `${b.p1 - b.p0 + 1} цаг` };
  });
}

const NowBadge = () => <span className="now-badge">Одоо</span>;

function BlockCard({ b, col }) {
  return (
    <div className={`block k-${b.kind}${b.isNow ? " is-now" : ""}`} style={{ gridColumn: col, gridRow: `${ROW(b.p0)} / ${ROW(b.p1) + 1}` }}>
      <div className="block__head"><div className="block__title">{b.title}</div>{b.isNow && <NowBadge />}</div>
      {b.sub && <div className="block__sub">{b.sub}</div>}
      {b.opts.length > 0 && (
        <div className="block__opts">
          {b.opts.map((o, i) => (
            <div key={i} className="block__opt"><span className="block__opt-s" title={o.t ? `${o.s} · ${o.t}` : undefined}>{o.s}</span><span className="room">{o.r}</span></div>
          ))}
        </div>
      )}
    </div>
  );
}

function TimeCell({ p, time, alt, compact }) {
  return (
    <div className="time-cell" style={{ gridRow: ROW(p) }}>
      <div className="time-cell__label">{compact ? (p === 0 ? "Ө" : p) : p === 0 ? "Өглөө" : `${p}-р цаг`}</div>
      <div className="time-cell__time">{time.join("–")}</div>
      {alt && <div className="time-cell__alt">{alt}</div>}
    </div>
  );
}

const Lunch = ({ meta }) => <div className="lunch" style={{ gridRow: 7 }}>Үдийн хоол · {meta?.lunch?.join("–")}</div>;

// Долоо хоног — 5 өдөр зэрэгцээ
export function WeekGrid({ slots, meta, ctx, compact }) {
  const all = [1, 2, 3, 4, 5].map((d) => buildBlocks(slots, d, meta, ctx));
  const maxP = Math.max(4, ...all.map((bs) => bs[bs.length - 1].p1));
  const today = dayjs().day() || 7;
  return (
    <div className="week-card">
      <div className="week-grid" style={{ gridTemplateRows: gridRows(maxP, "44px", compact) }}>
        {(compact ? DAY_SHORT : DAY_MN).map((n, i) => <div key={n} className={`day-head${i + 1 === today ? " is-today" : ""}`} style={{ gridColumn: i + 2 }}>{n}</div>)}
        {Array.from({ length: maxP + 1 }, (_, p) => (
          <TimeCell key={p} p={p} compact={compact} time={meta?.periods?.[p] || ["", ""]} alt={meta?.periodsTueThu?.[p] ? `Мя, Пү: ${meta.periodsTueThu[p].join("–")}` : ""} />
        ))}
        <Lunch meta={meta} />
        {all.map((bs, di) => bs.map((b) => <BlockCard key={`${di}-${b.p0}`} b={b} col={di + 2} />))}
      </div>
    </div>
  );
}

export function DayTabs({ day, onDay }) {
  return (
    <div className="day-tabs" role="tablist">
      {DAY_SHORT.map((s, i) => (
        <button key={s} type="button" role="tab" className="chip" aria-selected={day === i + 1} aria-label={DAY_MN[i]} onClick={() => onDay(i + 1)}>{s}</button>
      ))}
    </div>
  );
}

// Өдрөөр — жагсаалт
export function DayList({ slots, meta, ctx, day, onDay }) {
  const blocks = buildBlocks(slots, day, meta, ctx);
  return (
    <div className="day-view">
      <DayTabs day={day} onDay={onDay} />
      <div className="day-list">
        {blocks.map((b) => (
          <div key={b.p0} className={`day-item k-${b.kind}${b.isNow ? " is-now" : ""}`}>
            <div className="day-item__times"><div className="day-item__start">{b.start}</div><div className="day-item__end">{b.end}</div></div>
            <div className="day-item__body">
              <div className="day-item__head"><span className="day-item__title">{b.title}</span><span className="day-item__dur">{b.dur}</span>{b.isNow && <NowBadge />}</div>
              {b.sub && <div className="day-item__sub">{b.sub}</div>}
              {b.opts.length > 0 && (
                <div className="day-item__opts">
                  {b.opts.map((o, i) => (
                    <div key={i} className="day-item__opt"><span>{o.s} {o.t && <span className="day-item__opt-t">· {o.t}</span>}</span><span className="room">{o.r}</span></div>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Бүх анги — нэг өдөр, анги бүр зэрэгцээ. Ангийн толгой дээр дарахад тэр ангийг нээнэ.
export function AllGrid({ slots, meta, sections, homeRoom, day, onDay, onPick }) {
  const per = sections.map((g) => buildBlocks(slots.filter((s) => sectionCodes(s).includes(g.code)), day, meta, { view: "section", code: g.code }));
  const maxP = Math.max(4, ...per.map((bs) => bs[bs.length - 1].p1));
  const morning = per[0]?.[0];
  return (
    <div className="all-view">
      <DayTabs day={day} onDay={onDay} />
      <div className="week-card">
        <div className="all-grid" style={{ gridTemplateColumns: `88px repeat(${sections.length}, minmax(136px, 1fr))`, minWidth: 88 + sections.length * 140 + 16, gridTemplateRows: gridRows(maxP, "52px") }}>
          {sections.map((g, i) => (
            <button key={g.code} type="button" className="class-head" title={`${g.code} ангийн хуваарь`} style={{ gridColumn: i + 2 }} onClick={() => onPick(g.code)}>
              <span>{g.code}</span><span className="class-head__room">{homeRoom(g.code) || ""}</span>
            </button>
          ))}
          {Array.from({ length: maxP + 1 }, (_, p) => <TimeCell key={p} p={p} time={timeFor(meta, day, p)} />)}
          {morning && <div className={`all-morning${morning.isNow ? " is-now" : ""}`} style={{ gridRow: ROW(0) }}>{morning.title}</div>}
          <Lunch meta={meta} />
          {per.map((bs, ci) => bs.filter((b) => b.kind !== "morning").map((b) => <BlockCard key={`${ci}-${b.p0}`} b={b} col={ci + 2} />))}
        </div>
      </div>
    </div>
  );
}

export function Legend() {
  return (
    <div className="legend">
      {LEGEND.map(([k, l]) => <div key={k} className="legend__item"><span className={`legend__swatch k-${k}`} /><span>{l}</span></div>)}
    </div>
  );
}
